import { AxiosResponse } from "axios";
import { GenericService } from "./Generic.service";


export class AcessoProntuarioService extends GenericService<string> {
  readonly URI: string = "AcessoProntuario";

  constructor() {
    super();
    this.setUri(this.URI);
  }

  public async registrarJustificativa(body: any){
    return await super.post(body);
  }

}
